import { ChangeEvent } from "react";
import { useController, Control } from "react-hook-form";

import IconCheckmark from "./icon-checkmark.svg?react";
import IconCheckmarkSecondary from "./icon-checkmark-secondary.svg?react";

type CheckboxType = {
  name: string;
  variant?: "checkbox" | "switch" | "box";
  theme?: "purple" | "blue" | "red" | "green" | "grey" | "yellow";
  containerClassName?: string;
  className?: string;
  alignment?: "vertical" | "horizontal";
  formLabel?: string;
  isRequired?: boolean;
  disabled?: boolean;
  useSecondaryCheckmark?: boolean;
  onInputChange?: (e: ChangeEvent, value: string) => void;
  control?: Control<any>;
  label?: string;
  width?: string;
};

export const CheckboxField = (props: CheckboxType) => {
  const {
    name,
    theme = "purple",
    onInputChange,
    variant = "checkbox",
    className = "",
    alignment = "vertical",
    containerClassName,
    formLabel,
    isRequired = false,
    disabled = false,
    useSecondaryCheckmark = false,
    control,
    label = "",
    width = "unset",
  } = props;

  const {
    field: { onChange, value, ref },
  } = useController({
    name,
    control,
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onInputChange) {
      onInputChange(e, e.target.value);
    }
    onChange(e);
  };

  const isChecked = Boolean(value);

  return (
    <div
      style={{ width: width }}
      className={`${
        containerClassName !== undefined ? containerClassName : ""
      }`}
    >
      {formLabel && (
        <label className="theme-form-input-label" htmlFor={`field-${name}`}>
          {formLabel} {isRequired && <span>*</span>}{" "}
        </label>
      )}

      <div
        className={`theme-checkbox-container theme-checkbox-variant-${variant} theme-checkbox-align-${alignment}`}
      >
        {variant === "switch" ? (
          <label
            className={`theme-checkbox-switch ${
              disabled && "theme-checkbox-disabled"
            } theme-checkbox-color-${theme} ${className}`}
            key={`input-checkbox-${name}`}
          >
            <input
              id={`input-checkbox-${name}`}
              type="checkbox"
              value={label}
              checked={isChecked}
              name={name}
              disabled={disabled}
              onChange={handleChange}
              ref={ref}
            />
            <span className="theme-checkbox-switch-slider" />
          </label>
        ) : (
          <div
            style={{ width: "100%" }}
            className={`theme-checkbox ${
              disabled && "theme-checkbox-disabled"
            } theme-checkbox-color-${theme} ${className}`}
            key={`input-checkbox-${name}`}
          >
            <input
              id={`input-checkbox-${name}`}
              type="checkbox"
              value={label}
              checked={isChecked}
              name={name}
              disabled={disabled}
              onChange={handleChange}
              ref={ref}
            />
            <label
              style={{
                width: "100%",
                ...(variant === "box" && {
                  background: isChecked ? "#e8e9f9" : "white",
                }),
              }}
              htmlFor={`input-checkbox-${name}`}
              className="theme-checkbox-label"
            >
              {label}
              {useSecondaryCheckmark ? (
                <IconCheckmarkSecondary />
              ) : (
                <IconCheckmark />
              )}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckboxField;
